import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { SUPPORTED_LANGS } from '@constants';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class I18nLazyloadedResolver {
  private translateService = inject(TranslateService);
  private http = inject(HttpClient);

  private loadedLangs: { [translation: string]: { [lang: string]: boolean } } = {};

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const translationsNames: string[] = route.data.translationsNames ?? [];

    const langLoaders = translationsNames
      .map(translationsNames => {
        if (!this.loadedLangs[translationsNames]) {
          this.loadedLangs[translationsNames] = {};
        }

        return SUPPORTED_LANGS.map(langKey => {
          if (this.loadedLangs[translationsNames][langKey]) {
            return of(null);
          } else {
            const path = `assets/i18n/${translationsNames}/${langKey}.json`;
            return this.http.get<TranslationObject>(path).pipe(
              map(translations => {
                this.translateService.setTranslation(langKey, translations, true);
                this.loadedLangs[translationsNames][langKey] = true;
                // eslint-disable-next-line no-console
                console.info(`Language ${translationsNames}/${langKey} loaded`);
              })
            );
          }
        });
      })
      .flat();

    // A resolver must emit at least one value, otherwise Angular's router throws
    // `EmptyError: no elements in sequence` and cancels the navigation. When there
    // is nothing to load, `forkJoin([])` completes without emitting, so guard it.
    if (langLoaders.length === 0) {
      return of(null);
    }

    return forkJoin(langLoaders);
  }
}
